
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2"><i class="fa fa-warning text-danger mr-2 "></i>Reset Two-Factor Authentication</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div>
      <div class="font-weight-bold">Are you sure you want to reset two-factor authentication?</div>
      <div class="mt-2">
        When two-factor authentication is reset,
        the next time you log in you will be prompted to setup two-factor authentication again.
      </div>
    </div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="accept()">Reset</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
  </div>
</div>
